import {Component, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {
  BaseSupervisorSearchListComponent
} from "../supervisor-search-and-list-modal/base-supervisor-search-and-list.component";
import {ISupervisor} from "../../../../model/supervisor.model";
import {SharedPrimitivesModule} from "../../../../shared-primitives.module";
import {SupervisorSearchComponent} from "../../../supervisor-search/supervisor-search.component";
import {SupervisorInfoCardComponent} from "../../../supervisor-info-card/supervisor-info-card.component";
import {IconComponent} from "../../../../icon/icon.component";

@Component({
  selector: 'app-blacklist-modal',
  templateUrl: './blacklist-modal.component.html',
  styleUrl: './blacklist-modal.component.scss',
  standalone: true,
  imports: [
    SharedPrimitivesModule,
    IconComponent,
    SupervisorSearchComponent,
    SupervisorInfoCardComponent
  ]
})
export class BlacklistModalComponent extends BaseSupervisorSearchListComponent implements OnInit {

  @Input() public typeName: string | undefined = '';
  @Input() public isLeadSupervisor: boolean = false;

  public subtext: string = '';
  public subtext2: string = '';
  public showInactive: boolean = false;
  public textFilter: string = '';

  public formReason: UntypedFormGroup = new UntypedFormGroup({});

  @Output() blacklistReasonEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    fb: UntypedFormBuilder,
    elementRef: ElementRef,
  ) {
    super(fb, elementRef);
  }

  override ngOnInit() {
    if (this.typeName?.toLowerCase() == 'organization') {
      this.subtext = 'If blacklisted, this organization will not be able to create any new service opportunities for students. Supervisors will need to be individually blacklisted as needed. Current registrations will remain active.';
    } else if (this.typeName?.toLowerCase() == 'supervisor') {
      this.subtext = 'If blacklisted, this supervisor will no longer be able to serve as a supervisor for any CSER organizations or opportunities. ';
      this.subtext2 = 'This supervisor will be replaced with the lead supervisor.  If this supervisor is the lead, select replacement.';
    }

    this.formReason = this.fb.group({
      reason: [null, [Validators.required, Validators.maxLength(1000)]]
    });

    this.initializeForms();

  }

  public onSearchResults(results: any[]) {
    this.supervisors = results.map(result => result.sup);
    this.filteredSupervisors = this.supervisors;
  }

  override selectSupervisor(supervisor: ISupervisor) {
    this.selectedSupervisors = this.isSelected(supervisor) ? [] : [supervisor];
  }

  public isFormInValid(): boolean {
    if (this.isLeadSupervisor) {
      return (this.selectedSupervisors.length < 1 || this.formReason.invalid);
    } else {
      return this.formReason.invalid;
    }
  }

  public emitBlacklistReasonEvent() {
    if (this.selectedSupervisors.length === 1) {
      this.blacklistReasonEvent.emit({
        reason: this.formReason.get('reason')?.value,
        replacementSup: this.selectedSupervisors[0]
      });
    } else {
      this.blacklistReasonEvent.emit({
        reason: this.formReason.get('reason')?.value,
        replacementSup: undefined
      });
    }
    this.close();
  }

}
